export default __webpack_public_path__ + "static/media/GK-stops-map.772e4c05.jpg";